<template>
    <div class="accounting-items-relation-setting-page">
        <!-- 表格 -->
        <div class="colums-layout">
            <!-- 分類 -->
            <div class="column-panel category-column">
                <div class="column-title">收支分類</div>
                <div class="column-body">
                    <div class="scroll-view">
                        <div v-for="c in categoris" :key="c.key" class="setting-item categroy" :class="{ active: activeCategroyName === c.key }" @click="onCategoryClick(c.key)">{{ c.value }}</div>
                    </div>
                </div>
            </div>
            <!-- 大群組 -->
            <div class="column-panel group-column">
                <div class="column-title">收支大群組</div>
                <div class="column-body">
                    <div class="scroll-view">
                        <template v-if="activeCategory">
                            <div v-for="g in activeCategory" :key="g.sno" class="setting-item group" :class="{ active: activeGroup === g }" @click="onGroupClick(g)">
                                <span>{{ g.iteM_NAM }}</span>
                                <span v-if="g.iS_SYS" class="item-label">系統</span>
                                <span v-else-if="g.copySno" class="item-label">鏡像</span>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <!-- 子項目 -->
            <div class="column-panel item-column">
                <div class="column-title">子項目對應</div>
                <div class="column-body">
                    <div class="scroll-view">
                        <table v-if="activeGroup" class="child-item-table" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th>收支項目名稱</th>
                                    <th>歸屬會計明細科目</th>
                                    <th>其他建議科目</th>
                                    <th>編輯</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in activeGroup.childSettings" :key="item.sno" class="setting-item item" @click="onItemClick(item)">
                                    <td class="name">{{ item.iteM_NAM }}</td>
                                    <td class="accouting-input">
                                        <div class="default-disable-label" v-if="item.iS_SYS">系統預設項目，無需設定。</div>
                                        <div class="default-disable-label" v-else-if="item.copySno">此為鏡像項目，無需設定。</div>
                                        <div v-else>
                                            <ah-select-accounting-setting
                                                v-model="item.accsno"
                                                :allowedGroups="itemSettingAccoutingMapping[activeCategroyName]"
                                                size="small"
                                                style="width: 220px"
                                                use-sno
                                                @change="onAccoChange($event, item)"
                                            />
                                            <!-- <el-tag type="success" size="small" style="margin-left: 12px;" :style="{ opacity: savedItemSnoList.includes(item.sno) ? 1 : 0 }">
                                                    <i class="el-icon-check" /> 已儲存
                                                </el-tag> -->
                                        </div>
                                    </td>
                                    <td class="suggest-acc-items">
                                        {{ getSuggestedAccItemsTxt(item) }}
                                    </td>
                                    <td>
                                        <el-button v-if="!item.iS_SYS && !item.copySno && !isQR()" icon="el-icon-more" size="mini" @click="onItemEditClick(item)"></el-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="column-body-footer" v-if="activeGroup">
                            <el-button v-if="isAuth('F05') && !activeGroup.copySno && !activeGroup.iS_SYS" icon="el-icon-plus" size="mini" @click="onAddItemClick">新增子項目</el-button>
                            <div v-if="!isAuth('F05')">
                                <el-tooltip content="您沒有'收支項目設定'的權限" placement="top" effect="light">
                                    <el-button icon="el-icon-plus" size="mini" disabled>新增子項目</el-button>
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <IncomeStatementDetailEditor
            :visible="itemDetailEditorDialog.visible"
            :full-list="itemSettings"
            :target="itemDetailEditorDialog.target"
            :isTop="itemDetailEditorDialog.isTop"
            :accounting-items="filterdAccountingOption(activeCategroyName)"
            @delete="onItemDetailEditorDialogDelete"
            @update="onItemDetailEditorDialogUpdate"
            @close="onItemDetailEditorDialogClose"
            @closed="itemDetailEditorDialog.target = null"
        />
    </div>
</template>

<script>
import _ from 'lodash';
import IncomeStatementDetailEditor from '@/components/dashboard/Finance/TradeStatementSetting/IncomeStatementDetailEditor.vue';
import ahSelectAccountingSetting from '@/components/ui/ahSelectAccountingSetting.vue';

export default {
    components: { IncomeStatementDetailEditor, ahSelectAccountingSetting },
    data() {
        return {
            isLoading: false,
            activeCategroyName: null,
            activeCategory: null,
            // activeGroup: null,
            activeGroupSno: null,
            activeItem: null,
            savedItemSnoList: [],
            categoris: [
                { key: 'invoiceSettings', value: '營業收入', type: 3 },
                { key: 'payoutSettings', value: '營業支出', type: 4 },
                { key: 'cInSettings', value: '營業其他收入', type: 1 },
                { key: 'cOutSettings', value: '營業其他支出', type: 2 },
                { key: 'cInElseSettings', value: '財務資產收入', type: 5 },
                { key: 'cOutElseSettings', value: '財務資產支出', type: 6 },
            ],
            accoutingSettings: {
                // 會計科目列表
                assetsSettings: [], // 1
                liabilitiesSettings: [], // 2
                shareholderSettings: [], // 3
                revSettings: [], // 4
                costSettings: [], // 5
                oeSettings: [], // 6
                norSettings: [], // 7
                noeSettings: [], // 8
                taxSettings: [], // 9
            },
            itemSettings: {
                invoiceSettings: [],
                payoutSettings: [],
                cInSettings: [],
                cOutSettings: [],
                cInElseSettings: [],
                cOutElseSettings: [
                    {
                        // "sno": 957,
                        // "mno": 24,
                        // "fsno": 309,
                        // "iteM_NO": null,
                        // "iteM_NAM": "XX貸款測試",
                        // "accsno": null,
                        // "unt": "C_IN_ELS",
                        // "iS_SYS": true,
                        // "sot": 6,
                        // "isshare": false,
                        // "grP_NAM": 0,
                        // "grP_MEM": null,
                        // "grP_AMT": 0,
                        // "copySno": null,
                        // "isTop": false,
                        // "childSettings": []
                    },
                ],
            },
            // 對照表可選的分類
            itemSettingAccoutingMapping: {
                invoiceSettings: ['assetsSettings', 'liabilitiesSettings', 'revSettings', 'costSettings', 'oeSettings', 'norSettings'], // 1, 2, 4, 5, 6, 7
                payoutSettings: ['assetsSettings', 'liabilitiesSettings', 'revSettings', 'costSettings', 'oeSettings', 'norSettings', 'noeSettings'], // 1, 2, 4, 5, 6, 7, 8
                cInSettings: ['norSettings', 'revSettings', 'oeSettings'], // 7, 4, 6
                cOutSettings: ['oeSettings', 'noeSettings'], // 6, 8
                cInElseSettings: ['assetsSettings', 'liabilitiesSettings', 'shareholderSettings'], // 1, 2, 3
                cOutElseSettings: ['assetsSettings', 'liabilitiesSettings', 'shareholderSettings', 'taxSettings'], // 1, 2, 3, 9
            },
            itemDetailEditorDialog: {
                visible: false,
                target: null,
                isTop: undefined,
            },
        };
    },
    async mounted() {
        await this.$store.dispatch('accounting/updateAccountingSettings');
        await this.updateData();
        await this.fetchAccountingOptions();

        // 預先選取第一個項目
        await this.onCategoryClick('invoiceSettings');
        this.onGroupClick(this.activeCategory[0]);
    },
    computed: {
        activeCategoryGroups() {
            return this.itemSettings[this.activeCategroyName];
        },
        activeGroup() {
            if (this.activeCategoryGroups) {
                return this.activeCategoryGroups.find((g) => g.sno === this.activeGroupSno);
            }
            return null;
        },
    },
    methods: {
        async fetchAccountingOptions() {
            const resp = await this.$api({
                url: 'Tool/GetAccountingSettings',
                method: 'GET',
            });
            if (resp) {
                this.accoutingSettings.assetsSettings = resp.data.assetsSettings; // 1
                this.accoutingSettings.liabilitiesSettings = resp.data.liabilitiesSettings; // 2
                this.accoutingSettings.shareholderSettings = resp.data.shareholderSettings; // 3
                this.accoutingSettings.revSettings = resp.data.revSettings; // 4
                this.accoutingSettings.costSettings = resp.data.costSettings; // 5
                this.accoutingSettings.oeSettings = resp.data.oeSettings; // 6
                this.accoutingSettings.norSettings = resp.data.norSettings; // 7
                this.accoutingSettings.noeSettings = resp.data.noeSettings; // 8
                this.accoutingSettings.taxSettings = resp.data.taxSettings; // 9
            }
        },
        async updateData() {
            try {
                this.isLoading = true;
                const resp = await this.$api({
                    url: 'Tool/GetIncomeStatementSettings',
                    method: 'GET',
                });
                await this.$api({
                    url: 'AccountingSettingPage/GetDepositCompareSettings',
                    method: 'GET',
                });
                this.itemSettings = resp.data;
            } finally {
                this.isLoading = false;
            }
        },
        onCategoryClick(categoryName, preSelectGroup = true) {
            const category = this.itemSettings[categoryName];
            if (!category) {
                console.error('找不到群組：', categoryName);
                return;
            }
            this.activeCategroyName = categoryName;
            this.activeCategory = category;

            // 預先選取前次點選大群組
            if (preSelectGroup) {
                if (this.activeCategory.lastActiveGroup) {
                    this.onGroupClick(this.activeCategory.lastActiveGroup);
                } else {
                    this.onGroupClick(this.activeCategory[0]);
                }
            }
        },
        onGroupClick(group) {
            this.activeGroupSno = group.sno;
            this.activeCategory.lastActiveGroup = group;
        },
        onItemClick(item) {
            this.activeItem = item;
        },
        filterdAccountingOption(activeGroupName) {
            const options = [];

            // 用收支項目分類取得對應的會計科目分類選項
            const availableCategories = this.itemSettingAccoutingMapping[activeGroupName];
            if (!availableCategories) return [];

            // 把有效分類的會計項目 merge 成一維陣列
            availableCategories.forEach((categoryName) => {
                const accountingItems = this.accoutingSettings[categoryName];
                accountingItems.forEach((accItem) => {
                    // 轉換為 select option 格式
                    options.push({
                        accno: accItem.accno,
                        accnam: accItem.accnam,
                        label: `${accItem.accno} - ${accItem.accnam}`,
                        key: accItem.sno,
                        value: accItem.sno,
                    });
                });
            });
            return options;
        },
        async onAccoChange($event, item) {
            try {
                await this.$api({
                    url: '/IncomeStatementSettingPage/UpdateItem',
                    method: 'POST',
                    data: {
                        sno: item.sno,
                        fsno: item.fsno,
                        iteM_NAM: item.iteM_NAM,
                        grP_MEM: item.grP_MEM,
                        accsno: $event.sno,
                        isTop: item.isTop,
                    },
                });
                this.$store.dispatch('statement/updateStatementOptions');

                if (!this.savedItemSnoList.includes(item.sno)) {
                    this.savedItemSnoList.push(item.sno);
                }
                this.$message({ type: 'success', message: `已儲存 ${$event.accno} - ${$event.accnam}`, duration: 1000 });
            } catch (ex) {
                console.log('error', ex);
                this.$message.error('儲存失敗');
                item.accsno = null;
            }
        },
        onItemEditClick(item) {
            this.itemDetailEditorDialog.target = {
                ...item,
                parent: this.activeGroup.sno,
                category: _.find(this.categoris, ['key', this.activeCategroyName]).type,
            };
            this.itemDetailEditorDialog.visible = true;
        },
        onAddItemClick() {
            this.itemDetailEditorDialog.target = {
                parent: this.activeGroup.sno,
                category: _.find(this.categoris, ['key', this.activeCategroyName]).type,
            };
            this.itemDetailEditorDialog.visible = true;
        },
        async onItemDetailEditorDialogDelete({ sno, isGroup }) {
            const target = isGroup ? 'Group' : 'Item';

            try {
                await this.$api({
                    url: `/IncomeStatementSettingPage/Delete${target}`,
                    method: 'POST',
                    data: { sno },
                });
                this.onItemDetailEditorDialogClose();
                this.$message({ type: 'success', message: '已刪除', duration: 1000 });
            } catch (ex) {
                console.error(ex);
                this.$message.error('刪除失敗');
            } finally {
                this.updateData();
            }
        },
        onItemDetailEditorDialogUpdate() {
            this.updateData();
        },
        onItemDetailEditorDialogClose() {
            this.itemDetailEditorDialog.visible = false;
        },

        getSuggestedAccItemsTxt(row) {
            const INTERSECTION = _.chain(row.suggestedAccItems).map('accnam').value();

            return INTERSECTION.join(', ');
        },
    },
};
</script>
<style lang="scss">
.accounting-items-relation-setting-page {
    .colums-layout {
        display: grid;
        width: 100%;
        grid-template-columns: 200px 300px auto;
        gap: 10px;

        .column-panel {
            background-color: #fff;
            border-radius: 10px;
            border: 1px solid #e7e7e7;
        }

        .column-title {
            color: #666;
            font-size: 11pt;
            font-weight: bold;
            background-color: #fff;
            text-align: center;
            padding: 12px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            border-bottom: 1px solid #e7e7e7;
        }

        .column-body {
            height: calc(100vh - 300px);

            > .scroll-view {
                height: calc(100vh - 300px);
                overflow: auto;
                padding: 12px 12px 50px 12px;
            }
            .column-body-footer {
                padding: 10px 0;
            }
        }
    }
    .setting-item {
        cursor: pointer;
        font-size: 11pt;
        font-weight: normal;
        padding: 5px 15px;
        background-color: #fff;
        border-bottom: 1px solid #eee;

        &:hover {
            background-color: #f4f6ff;
        }

        &.category {
        }
        &.group {
        }
        &.item {
        }

        &.active {
            color: #463cb2;
            background-color: #f4f6ff;
            font-weight: bold;
        }
        .item-label {
            display: inline-block;
            margin-left: 7px;
            padding: 0px 4px;
            line-height: 20px;
            color: #aaa;
            font-size: 9pt;
            border: 1px solid #ccc;
            border-radius: 5px;
            white-space: nowrap;
        }
    }
    .child-item-table {
        width: 100%;

        td,
        th {
            text-align: left;
            font-size: 11pt;
            border-bottom: 1px solid #eee;
            padding: 5px 10px;
        }
    }

    .default-disable-label {
        color: #888;
        font-size: 10pt;
    }

    .suggest-acc-items {
        max-width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
